import { compact } from 'lodash-es';
import { AccountingStatusFilter } from '~/business-logic/qboStatusFilterLogic';
export const payoutsTextsPath = 'payouts';
export const payoutsAccountingStatusTextsPath = 'payouts.accountingStatusLabels';
export const payoutsColumnHeadersTextsPath = 'payouts.columnHeaders';
export var PayoutsFilterType = /*#__PURE__*/ function(PayoutsFilterType) {
    PayoutsFilterType["QboStatus"] = "qboStatus";
    PayoutsFilterType["XeroStatus"] = "xeroStatus";
    return PayoutsFilterType;
}({});
export var HeaderItemId = /*#__PURE__*/ function(HeaderItemId) {
    HeaderItemId["Status"] = "status";
    HeaderItemId["Amount"] = "amount";
    HeaderItemId["PayoutId"] = "payoutId";
    HeaderItemId["DepositDate"] = "depositDate";
    HeaderItemId["SyncStatus"] = "syncStatus";
    return HeaderItemId;
}({});
const sortByDepositDate = (a, b)=>b.createdAt() - a.createdAt();
const sortById = (a, b)=>a.id() < b.id() ? -1 : 1;
const sortByAmount = (a, b)=>b.amount().sub(a.amount()).toNumber();
const sortByFormattedNumber = (a, b)=>a.formattedNumber() < b.formattedNumber() ? -1 : 1;
const sortFunctions = {
    ["depositDate"]: (isAscending)=>(a, b)=>{
            const retval = sortByDepositDate(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        },
    ["status"]: (isAscending)=>(a, b)=>{
            // Status is always 'paid' so there's nothing to sort in this column.
            const retval = sortById(a, b);
            return isAscending ? -retval : retval;
        },
    ["amount"]: (isAscending)=>(a, b)=>{
            const retval = sortByAmount(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        },
    ["payoutId"]: (isAscending)=>(a, b)=>{
            const retval = sortByFormattedNumber(a, b);
            return isAscending ? -retval : retval;
        },
    ["syncStatus"]: ()=>()=>0
};
function applySearch(payouts, search) {
    const normalizedSearch = search ? search.trim().toLowerCase() : search;
    return payouts.filter((payout)=>{
        const searchWords = [
            payout.formattedNumber()
        ];
        payout.invoices().forEach((invoice)=>{
            searchWords.push(invoice.formattedNumber);
            const clientName = invoice.customer;
            clientName && searchWords.push(clientName);
        });
        return searchWords.join(' ').toLowerCase().includes(normalizedSearch);
    });
}
function applyQboStatusFilter(payouts, qboStatusFilter) {
    switch(qboStatusFilter){
        case AccountingStatusFilter.All:
            return payouts;
        case AccountingStatusFilter.Synced:
            return payouts.filter((p)=>p.isQboSynced());
        case AccountingStatusFilter.NotSynced:
            return payouts.filter((p)=>!p.isQboSynced());
    }
}
function applyXeroStatusFilter(payouts, xeroStatusFilter) {
    switch(xeroStatusFilter){
        case AccountingStatusFilter.All:
            return payouts;
        case AccountingStatusFilter.Synced:
            return payouts.filter((p)=>p.isXeroSynced());
        case AccountingStatusFilter.NotSynced:
            return payouts.filter((p)=>!p.isXeroSynced());
    }
}
export function applyFilters(param) {
    let { payouts, qboStatusFilter, xeroStatusFilter, search } = param;
    let filtered = payouts;
    filtered = applySearch(filtered, search);
    if (qboStatusFilter != null) {
        filtered = applyQboStatusFilter(filtered, qboStatusFilter);
    }
    if (xeroStatusFilter != null) {
        filtered = applyXeroStatusFilter(filtered, xeroStatusFilter);
    }
    return filtered;
}
export function applySort(payouts, sort, headerItemId) {
    if (sort && headerItemId) {
        payouts.sort(sortFunctions[headerItemId](sort.sort === 'asc'));
    }
    return payouts;
}
export function getAccountingStatusFilterOptions(param) {
    let { counters, texts } = param;
    const syncedCounter = counters.synced || 0;
    const notSyncedCounter = counters.notSynced || 0;
    const options = [
        {
            value: AccountingStatusFilter.All,
            label: texts.all(),
            counter: syncedCounter + notSyncedCounter
        },
        {
            value: AccountingStatusFilter.Synced,
            label: texts.synced(),
            counter: syncedCounter
        },
        {
            value: AccountingStatusFilter.NotSynced,
            label: texts.notSynced(),
            counter: notSyncedCounter
        }
    ];
    return options.filter((option)=>option.value === AccountingStatusFilter.All || option.counter > 0);
}
export function getAccountingStatusFilterOptionsFromPayouts(param) {
    let { payouts, checkSynced, texts } = param;
    const options = [
        {
            value: AccountingStatusFilter.All,
            label: texts.all(),
            counter: payouts.length
        },
        {
            value: AccountingStatusFilter.Synced,
            label: texts.synced(),
            counter: 0
        },
        {
            value: AccountingStatusFilter.NotSynced,
            label: texts.notSynced(),
            counter: 0
        }
    ];
    payouts.forEach((payout)=>{
        checkSynced(payout) && options[1].counter++;
        !checkSynced(payout) && options[2].counter++;
    });
    return options.filter((opt)=>opt.counter > 0);
}
export function getTableConfig(param) {
    let { showQboIntegration, showXeroIntegration, texts } = param;
    const data = compact([
        {
            columnDef: {
                width: showQboIntegration || showXeroIntegration ? 170 : 108,
                sortable: true,
                hAlign: 'start',
                mobile: {}
            },
            headerItem: {
                id: "payoutId",
                value: texts.payoutId()
            },
            defaultSortDirection: 'desc'
        },
        {
            columnDef: {
                width: 108,
                sortable: true,
                hAlign: 'end',
                mobile: {
                    label: {
                        text: texts.depositDate()
                    }
                }
            },
            headerItem: {
                id: "depositDate",
                value: texts.depositDate()
            },
            defaultSortDirection: 'desc'
        },
        {
            columnDef: {
                width: 30
            },
            headerItem: {
                id: null,
                value: null
            }
        },
        {
            columnDef: {
                width: 100,
                sortable: true,
                hAlign: 'end',
                mobile: {}
            },
            headerItem: {
                id: "status",
                value: texts.status()
            },
            defaultSortDirection: 'desc'
        },
        {
            columnDef: {
                width: [
                    100,
                    200
                ],
                sortable: true,
                hAlign: 'end',
                mobile: {}
            },
            headerItem: {
                id: "amount",
                value: texts.amount()
            },
            defaultSortDirection: 'desc'
        }
    ]);
    const sortOptions = data.flatMap((d, colIndex)=>d.columnDef.sortable && d.defaultSortDirection ? [
            {
                id: String(d.headerItem.id),
                label: String(d.headerItem.value),
                defaultDirection: d.defaultSortDirection,
                colIndex
            }
        ] : []);
    return {
        columnDefs: data.map((d)=>d.columnDef),
        headerItems: data.map((d)=>d.headerItem),
        sortOptions
    };
}
export const mapHeaderIdToBackendField = (headerId)=>{
    switch(headerId){
        case "payoutId":
            return 'formatted_number';
        case "depositDate":
            return 'deposit_date';
        case "status":
            return 'status';
        case "amount":
            return 'amount';
        default:
            return 'formatted_number';
    }
};
